module.exports = __webpack_public_path__ + "static/media/newX.14fe4a36.svg";